import React from 'react'

const ProductCell: React.FC<any> = props => {
	const { featurePicturePath, name, description } = props.row.original?.product

	return (
		<React.Fragment>
			<div className="row gx-10">
				<div className="d-xl-flex col-12 col-xl-2 px-0">
					<img
						className="ms-4"
						src={featurePicturePath}
						// src={
						// 	featurePicturePath
						// 		? generateImageUrl(featurePicturePath)
						// 		: '/media/icons/kumopack/default-placeholder.png'
						// }
						onError={(e: any) => {
							e.target.onerror = null
							e.target.src = '/media/icons/kumopack/default-placeholder.png'
						}}
						alt={name}
						height={78}
						style={{ userSelect: 'none', pointerEvents: 'none' }}
					/>
				</div>
				<div className="col-12 col-xl-10 d-flex flex-column" style={{ rowGap: '5px' }}>
					<div className="fw-bold text-kumopack-grey-900 fs-4">{name}</div>
					<p
						className="text-kumopack-grey-600 mb-0"
						dangerouslySetInnerHTML={{ __html: description }}></p>
				</div>
			</div>
		</React.Fragment>
	)
}

export default ProductCell
